import moment from 'moment';
import { checkForLecturerConflict, checkForLocationConflict, OnItemMoveArgs } from '@modules/timetable';
import { checkGroupChange } from './checkGroupChange';

export const onItemMove = async ({ itemID, dragTime, newGroupOrder, timelineItems, addToast }: OnItemMoveArgs) => {
  const itemIndex = timelineItems.findIndex((timelineItem) => timelineItem.id === itemID);
  const item = timelineItems[itemIndex];

  // If group change, show error
  let isTargetValid = checkGroupChange({
    newGroup: newGroupOrder,
    currentGroup: item.groupID,
    addToast,
  });

  if (isTargetValid) {
    const duration = moment.duration(item.endTime.diff(item.startTime)).asHours();
    const newStartTime = moment(dragTime);
    const newEndTime = moment(dragTime).add(duration, 'h');

    isTargetValid = await checkForLocationConflict({
      timelineItems,
      item,
      endTime: newEndTime,
      startTime: newStartTime,
    });

    if (isTargetValid) {
      isTargetValid = await checkForLecturerConflict({
        timelineItems,
        item,
        endTime: newEndTime,
        startTime: newStartTime,
      });

      if (isTargetValid) {
        // Update new position
        item.moveItem({
          startTime: newStartTime,
          endTime: newEndTime,
          groupID: newGroupOrder,
        });
      }
    }
  }
};
